import React from 'react';
import { SupplierProfileBuilderCertifications } from './SupplierProfileBuilderCertifications';

interface SupplierProfileBuilderStepCertificationsProps {
  supplierId: string;
  onCountChange?: (count: number) => void;
}

const SupplierProfileBuilderStepCertifications: React.FC<
  SupplierProfileBuilderStepCertificationsProps
> = ({ supplierId, onCountChange }) => {
  return (
    <SupplierProfileBuilderCertifications
      supplierId={supplierId}
      onCountChange={onCountChange}
    />
  );
};

export default SupplierProfileBuilderStepCertifications;
